import React from "react";

interface StarterKitNoticeModalProps {
  show: boolean;
  studentName?: string;
  courseName?: string;
  message?: string;
  onProceed: () => void;
  onGoToList: () => void;
}

const StarterKitNoticeModal: React.FC<StarterKitNoticeModalProps> = ({
  show,
  studentName,
  courseName,
  message,
  onProceed,
  onGoToList,
}) => {
  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1060 }}></div>
      <div
        className="modal fade show d-block"
        tabIndex={-1}
        style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1065 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow">
            <div className="modal-body text-center p-4">
              <div className="mb-3">
                <div
                  className="rounded-circle d-inline-flex align-items-center justify-content-center bg-warning-subtle text-warning"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className="ti ti-package-off" style={{ fontSize: "2.8rem" }}></i>
                </div>
              </div>

              <h4 className="modal-title fw-bold text-dark mb-2">Starter Kit Not Assigned</h4>

              <div className="alert alert-success d-flex align-items-center justify-content-center py-2 px-3 mb-3">
                <i className="ti ti-circle-check fs-5 me-2"></i>
                <span className="fw-medium">
                  {studentName ? `${studentName} was registered successfully!` : "Student registered successfully!"}
                </span>
              </div>

              <div className="alert alert-warning text-start mb-3 p-3">
                <div className="d-flex align-items-start">
                  <i className="ti ti-alert-triangle fs-4 text-warning me-2 mt-1"></i>
                  <div>
                    <h6 className="fw-semibold mb-1 text-warning-emphasis">Starter Kit Stock Empty</h6>
                    <p className="mb-0 fs-13 text-secondary">
                      {message ||
                        `Starter kit stock is currently empty for ${courseName || "this course"}. The kit could not be assigned automatically.`}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-light rounded p-3 text-start mb-4">
                <div className="d-flex">
                  <i className="ti ti-info-circle text-primary fs-5 me-2 mt-1"></i>
                  <p className="mb-0 fs-13 text-muted">
                    <strong>Note:</strong> Student registration is complete and was not affected. You can assign the starter kit to this student at any time from the <strong>Student List</strong> once inventory is available.
                  </p>
                </div>
              </div>

              <div className="d-flex justify-content-center gap-2">
                <button
                  type="button"
                  className="btn btn-outline-secondary px-3"
                  onClick={onGoToList}
                >
                  <i className="ti ti-list me-1"></i> Student List
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-4"
                  onClick={onProceed}
                >
                  <i className="ti ti-share me-1"></i> Share Registration Link
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StarterKitNoticeModal;

